import ModulePanel from "./ModulePanel";
import ModuleDetailPane from "./ModuleDetailPane";

const MODULE_KEY = "discovery";
const MODULE_LABEL = "Discovery";

/**
 * Deep link to the real Discovery page for one record — same
 * ?type=&id=&user_id=&customer_id= shape DiscoveryV2/Share/Share.js builds
 * and DiscoveryV2/Discovery.js itself reads on load to reopen a specific
 * transaction. `type` defaults to "brand" the same way discoveryCtx.type
 * does everywhere else in Discovery when it isn't otherwise known
 * (Discovery.js:85, HistoryV2.js:729).
 */
function buildFullViewUrl(record, { userId, customerId }) {
  if (!record?.transactionId || !userId) return null;
  const params = new URLSearchParams({
    // record.type is "Brand"/"Product" (capitalized, matching the raw API);
    // Discovery.js reads this query param verbatim into discoveryCtx.type
    // and compares it lowercase ("brand"/"product") everywhere — the radio
    // button and the Brand Pillars/Product Dimension table both read that
    // same value, so passing it capitalized silently matched neither.
    type: (record.type || "brand").toLowerCase(),
    id: record.transactionId,
    user_id: userId,
    customer_id: customerId,
  });
  return `/luminaire/discoveryV2?${params.toString()}`;
}

export default function DiscoveryModule() {
  return (
    <ModulePanel
      moduleKey={MODULE_KEY}
      moduleLabel={MODULE_LABEL}
      weightTag="single combination · point-in-time"
      DetailPane={ModuleDetailPane}
      buildFullViewUrl={buildFullViewUrl}
    />
  );
}
